import { CircleMarkerOptions, MapOptions, PathOptions, TooltipOptions } from 'leaflet';
import { BlockData, DistrictData } from '../models/maps.model';

export const INDIA_DATA: { [k: string]: { stateId: number, stateCode: string; }; } = {
    'andaman and nicobar': { stateId: 1, stateCode: 'AN' },
    'andhra pradesh': { stateId: 2, stateCode: 'AP' },
    'arunachal pradesh': { stateId: 3, stateCode: 'AR' },
    'assam': { stateId: 4, stateCode: 'AS' },
    'bihar': { stateId: 5, stateCode: 'BH' },
    'chhattisgarh': { stateId: 31, stateCode: 'CG' },
    'dnh and daman diu': { stateId: 36, stateCode: 'DN' },
    'goa': { stateId: 8, stateCode: 'GO' },
    'gujarat': { stateId: 9, stateCode: 'GJ' },
    'haryana': { stateId: 10, stateCode: 'HA' },
    'himachal pradesh': { stateId: 11, stateCode: 'HP' },
    'jammu and kashmir': { stateId: 12, stateCode: 'JK' },
    'jharkhand': { stateId: 32, stateCode: 'JH' },
    'karnataka': { stateId: 13, stateCode: 'KN' },
    'kerala': { stateId: 14, stateCode: 'KR' },
    'ladakh': { stateId: 35, stateCode: 'LD' },
    'lakshadweep': { stateId: 17, stateCode: 'LA' },
    'madhya pradesh': { stateId: 15, stateCode: 'MP' },
    'maharashtra': { stateId: 16, stateCode: 'MH' },
    'manipur': { stateId: 18, stateCode: 'MN' },
    'meghalaya': { stateId: 19, stateCode: 'MG' },
    'mizoram': { stateId: 20, stateCode: 'MZ' },
    'nagaland': { stateId: 21, stateCode: 'NG' },
    'odisha': { stateId: 22, stateCode: 'OR' },
    'puducherry': { stateId: 23, stateCode: 'PO' },
    'punjab': { stateId: 24, stateCode: 'PJ' },
    'rajasthan': { stateId: 25, stateCode: 'RJ' },
    'sikkim': { stateId: 26, stateCode: 'SK' },
    'tamil nadu': { stateId: 27, stateCode: 'TN' },
    'telangana': { stateId: 34, stateCode: 'TS' },
    'tripura': { stateId: 28, stateCode: 'TR' },
    'uttarakhand': { stateId: 33, stateCode: 'UK' },
    'uttar pradesh': { stateId: 29, stateCode: 'UP' },
    'west bengal': { stateId: 30, stateCode: 'WB' }
} as const;

export const LEAFLET_MAP_OPTIONS: MapOptions = {
    zoom: 5,
    zoomControl: false,
    scrollWheelZoom: false,
    doubleClickZoom: false,
    dragging: false,
    zoomDelta: 0.25,
    zoomSnap: 0
};

export const LEAFLET_MAP_STYLE: PathOptions = {
    color: '#ffffff',
    weight: 1,
    fillOpacity: 1,
    fillColor: '#2755A3',
    dashArray: ''
};

export const LEAFLET_TOOLTIP_OPTIONS: TooltipOptions = {
    sticky: true,
    direction: 'auto',
    className: 'leaflet-tooltip'
};

export const CIRCLE_MARKER_OPTIONS: CircleMarkerOptions = {
    color: '#F1810E',
    weight: 5,
    opacity: 0.4,
    fillOpacity: 1,
    className:'dot',
    radius:6
};

export const DEFAULT_BLOCK_LIST: (BlockData & { blockId: number; })[] = [{ blockName: '' } as BlockData & { blockId: number; }];

export const DEFAULT_DISTRICT_LIST: (DistrictData & { districtId: number; })[] = [{ districtName: '' } as DistrictData & { districtId: number; }];